(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4313,1993],{

/***/ 41993:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "DotIndicatorComponent": function() { return /* binding */ DotIndicatorComponent; },
/* harmony export */   "default": function() { return /* binding */ CarouselIndicator; },
/* harmony export */   "useGetChevronComponent": function() { return /* binding */ useGetChevronComponent; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(99534);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(10253);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(93967);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _svg__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69466);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(96486);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var src_components_DesignSystem_ModernTheme_utils_common__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(20901);
/* harmony import */ var _ListPresentation_utils__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(24200);
/* harmony import */ var _ListPresentation_hooks_useGetElementRects__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(18554);












var GAP = 36;
function CarouselIndicator(param) {
    var _config = param.config, config = _config === void 0 ? {} : _config, _isVisible = param.isVisible, isVisible = _isVisible === void 0 ? false : _isVisible, carouselIndicatorConfigs = param.carouselIndicatorConfigs, onNextArrowClick = param.onNextArrowClick, onPrevArrowClick = param.onPrevArrowClick, itemContainerLayoutChange = param.itemContainerLayoutChange, arrowPosition = param.arrowPosition, showArrowUI = param.showArrowUI, isMobile = param.isMobile, containerHorizontalPadding = param.containerHorizontalPadding;
    var _RenderSlider = function _RenderSlider() {
        switch(progressIndicator){
            case "fullWidthBar":
                {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(SliderComponent, {
                        width: "100%",
                        scrollPercentage: scrollPercentage,
                        progressIndicatorColor: progressIndicatorColor
                    });
                }
            case "shortProgressBar":
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(SliderComponent, {
                    height: "5px",
                    width: "132px",
                    scrollPercentage: scrollPercentage,
                    progressIndicatorColor: progressIndicatorColor
                });
            case "dashAndDots":
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(DotIndicatorComponent, {
                    overflowSectionCount: overflowSectionCount,
                    currentFocusedSectionItem: Math.round(currentFocusedSectionExact),
                    progressIndicatorColor: progressIndicatorColor,
                    direction: direction
                });
            default:
                return null;
        }
    };
    var _RenderArrows = function _RenderArrows() {
        var ref, ref1;
        var showArrow = showArrowUI && !arrowPositionKT.isTop;
        var arrowVerticalPositionOffset = ((ref = layoutWrapperLayoutChange.elementRect) === null || ref === void 0 ? void 0 : ref.clientHeight) + (!Slider ? -GAP : 0) + (itemContainerLayoutChange === null || itemContainerLayoutChange === void 0 ? void 0 : (ref1 = itemContainerLayoutChange.elementRect) === null || ref1 === void 0 ? void 0 : ref1.clientHeight) / 2;
        return {
            LeftArrow: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(LeftArrow, {
                isVisible: showArrow,
                className: arrowPositionKT.isCenter ? "tw-absolute tw-left-[-20px] tw-z-10 tw-translate-y-[-50%]" : "",
                style: {
                    bottom: arrowVerticalPositionOffset
                }
            }),
            RightArrow: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(RightArrow, {
                isVisible: showArrow,
                className: arrowPositionKT.isCenter ? "tw-absolute tw-right-[-20px] tw-z-10 tw-translate-y-[-50%]" : "",
                style: {
                    bottom: arrowVerticalPositionOffset
                }
            })
        };
    };
    var ref = carouselIndicatorConfigs || {}, direction = ref.direction, _scrollPercentage = ref.scrollPercentage, scrollPercentage = _scrollPercentage === void 0 ? 0 : _scrollPercentage, _overflowSectionCount = ref.overflowSectionCount, overflowSectionCount = _overflowSectionCount === void 0 ? 0 : _overflowSectionCount, _currentFocusedSectionExact = ref.currentFocusedSectionExact, currentFocusedSectionExact = _currentFocusedSectionExact === void 0 ? 0 : _currentFocusedSectionExact;
    var ref1 = config || {}, progressIndicator = ref1.progressIndicator, arrowShape = ref1.arrowShape, _progressIndicatorColor = ref1.progressIndicatorColor, progressIndicatorColor = _progressIndicatorColor === void 0 ? "#111C36" : _progressIndicatorColor;
    var layoutWrapperRef = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)(null);
    var ref2 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_ListPresentation_hooks_useGetElementRects__WEBPACK_IMPORTED_MODULE_7__/* .useGetElementRects */ .w)({
        elementRef: layoutWrapperRef
    }), 1), layoutWrapperLayoutChange = ref2[0];
    var ref3 = useGetChevronComponent({
        type: arrowShape,
        onNextArrowClick: onNextArrowClick,
        onPrevArrowClick: onPrevArrowClick,
        scrollPercentage: scrollPercentage,
        isMobile: isMobile,
        colorConfig: {
            arrowColor: config.arrowColor,
            shapeColor: config.shapeColor
        }
    }), LeftArrow = ref3.LeftArrow, RightArrow = ref3.RightArrow;
    if (!isVisible) {
        return null;
    }
    var arrowPositionKT = {
        isTop: !isMobile ? arrowPosition === "top" : false,
        isCenter: !isMobile ? arrowPosition === "center" : false,
        isBottom: !isMobile ? arrowPosition === "bottom" : true
    };
    var Slider = _RenderSlider();
    var GAP_APPLIED = Slider || arrowPositionKT.isBottom ? 36 : 0;
    var Arrows = _RenderArrows();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        ref: layoutWrapperRef,
        className: "tw-relative tw-mx-auto tw-flex tw-w-[100%] tw-select-none tw-items-center tw-justify-center tw-gap-[20px]",
        style: {
            marginTop: "".concat(GAP_APPLIED, "px"),
            padding: "0px ".concat(containerHorizontalPadding, "px")
        },
        children: [
            Arrows.LeftArrow,
            Slider,
            Arrows.RightArrow
        ]
    });
}
function SliderComponent(param) {
    var _height = param.height, height = _height === void 0 ? "2px" : _height, width = param.width, scrollPercentage = param.scrollPercentage, progressIndicatorColor = param.progressIndicatorColor;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "tw-relative tw-rounded-[6px] tw-bg-[#111C361F]",
        style: {
            width: width,
            height: height,
            transform: "translateY(".concat(-height / 2, ")")
        },
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "tw-absolute tw-h-[100%] tw-rounded-[6px] tw-transition-all",
            style: {
                width: "".concat(scrollPercentage, "%"),
                background: progressIndicatorColor
            }
        })
    });
}
var CONTAINER_WIDTH = 120;
function DotIndicatorComponent(param) {
    var _overflowSectionCount = param.overflowSectionCount, overflowSectionCount = _overflowSectionCount === void 0 ? 0 : _overflowSectionCount, currentFocusedSectionItem = param.currentFocusedSectionItem, progressIndicatorColor = param.progressIndicatorColor, direction = param.direction, _containerWidth = param.containerWidth, containerWidth = _containerWidth === void 0 ? CONTAINER_WIDTH : _containerWidth, _styles = param.styles, styles = _styles === void 0 ? {} : _styles, _dimensions = param.dimensions, dimensions = _dimensions === void 0 ? {
        width: "tw-w-[5px]",
        widthOfSelected: "tw-w-[30px]",
        height: "tw-h-[5px]"
    } : _dimensions;
    var dotsContainerRef = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)(null);
    var dotsRef = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)([]);
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        var ref;
        var selectedIndex = currentFocusedSectionItem - 1;
        var selectedDotElement = (ref = dotsRef.current) === null || ref === void 0 ? void 0 : ref[selectedIndex];
        if (dotsContainerRef.current) {
            var ref1, ref2;
            dotsContainerRef.current.scrollTo({
                left: ((ref1 = dotsContainerRef.current) === null || ref1 === void 0 ? void 0 : ref1.scrollLeft) + (selectedDotElement === null || selectedDotElement === void 0 ? void 0 : selectedDotElement.getBoundingClientRect().left) - ((ref2 = dotsContainerRef.current) === null || ref2 === void 0 ? void 0 : ref2.getBoundingClientRect().left) + (direction === "to-right" ? -70 : -45),
                top: 0
            });
        }
    }, [
        currentFocusedSectionItem,
        overflowSectionCount,
        direction
    ]);
    if (!overflowSectionCount) {
        return null;
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        style: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({
            width: "".concat(containerWidth, "px")
        }, styles),
        className: "tw-flex tw-justify-center tw-gap-[6px]",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            ref: dotsContainerRef,
            className: "no-scrollbar tw-flex tw-items-center tw-gap-[6px] tw-overflow-x-auto",
            children: Array.from(Array(overflowSectionCount).keys()).map(function(_, index) {
                var isSelected = currentFocusedSectionItem === index + 1;
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    ref: function(node) {
                        return dotsRef.current[index] = node;
                    },
                    className: classnames__WEBPACK_IMPORTED_MODULE_1___default()("tw-h-[5px] tw-shrink-0 tw-rounded-[3px]  tw-transition-all", dimensions.height, !isSelected ? dimensions.width : dimensions.widthOfSelected || dimensions.width, !isSelected && "tw-bg-[#111C36]/[0.25]"),
                    style: isSelected ? {
                        background: progressIndicatorColor
                    } : {}
                }, index);
            })
        })
    });
}
function useGetChevronComponent(param) {
    var type = param.type, onNextArrowClick = param.onNextArrowClick, onPrevArrowClick = param.onPrevArrowClick, scrollPercentage = param.scrollPercentage, isMobile = param.isMobile, colorConfig = param.colorConfig, _dimensions = param.dimensions, dimensions = _dimensions === void 0 ? {
        width: {
            mobile: "28px",
            desktop: "36px"
        },
        height: {
            mobile: "28px",
            desktop: "36px"
        }
    } : _dimensions;
    var styles = function() {
        var styles = {
            border: "",
            borderRadius: "0",
            background: (colorConfig === null || colorConfig === void 0 ? void 0 : colorConfig.shapeColor) || ""
        };
        switch(type){
            case "circular":
                styles.border = "0.75px solid #111C361F";
                styles.borderRadius = "20";
                break;
            case "rounded":
                styles.border = "0.75px solid #111C361F";
                styles.borderRadius = "5";
                break;
            case "square":
                styles.border = "0.75px solid #111C361F";
                break;
            default:
                styles.background = "";
                break;
        }
        return styles;
    }();
    var removeBorder = type === "onlyArrow";
    var iconProps = {
        width: dimensions.width[isMobile ? "mobile" : "desktop"],
        height: dimensions.height[isMobile ? "mobile" : "desktop"],
        removeBorder: removeBorder,
        bgColor: styles.background,
        borderRadius: styles.borderRadius
    };
    return {
        LeftArrow: function(_param) {
            var _isVisible = _param.isVisible, isVisible = _isVisible === void 0 ? true : _isVisible, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(_param, [
                "isVisible"
            ]);
            return isVisible && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, props), {
                className: classnames__WEBPACK_IMPORTED_MODULE_1___default()(// isMobile ? 'tw-h-[28px]' : 'tw-h-[36px]',
                "tw-pointer-events-auto", scrollPercentage ? "tw-cursor-pointer" : " ", props.className),
                style: (0,lodash__WEBPACK_IMPORTED_MODULE_4__.merge)(props.style, {
                    width: dimensions.width[isMobile ? "mobile" : "desktop"],
                    height: dimensions.height[isMobile ? "mobile" : "desktop"]
                }, !removeBorder ? {
                    boxShadow: "0px 0px 1.5px 0px #111C3633",
                    borderRadius: styles.borderRadius + "px"
                } : {}),
                onClick: onPrevArrowClick,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_svg__WEBPACK_IMPORTED_MODULE_3__/* .RightArrowIcon */ .A, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({
                    className: "tw-rotate-180"
                }, iconProps), {
                    arrowColor: scrollPercentage <= _ListPresentation_utils__WEBPACK_IMPORTED_MODULE_6__/* .INITIAL_SCROLL_PERCENTAGE */ .Sk ? (0,src_components_DesignSystem_ModernTheme_utils_common__WEBPACK_IMPORTED_MODULE_5__/* .hexToRgba */ .a7)(colorConfig.arrowColor, 0.5) : colorConfig.arrowColor
                }))
            }));
        },
        RightArrow: function(_param) {
            var _isVisible = _param.isVisible, isVisible = _isVisible === void 0 ? true : _isVisible, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(_param, [
                "isVisible"
            ]);
            return isVisible && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, props), {
                className: classnames__WEBPACK_IMPORTED_MODULE_1___default()("tw-pointer-events-auto", // isMobile ? 'tw-h-[28px]' : 'tw-h-[36px]',
                scrollPercentage >= 100 ? "" : "tw-cursor-pointer ", props.className),
                style: (0,lodash__WEBPACK_IMPORTED_MODULE_4__.merge)(props.style, props.style, {
                    width: dimensions.width[isMobile ? "mobile" : "desktop"],
                    height: dimensions.height[isMobile ? "mobile" : "desktop"]
                }, !removeBorder ? {
                    boxShadow: "0px 0px 1.5px 0px #111C3633",
                    borderRadius: styles.borderRadius + "px"
                } : {}),
                onClick: onNextArrowClick,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_svg__WEBPACK_IMPORTED_MODULE_3__/* .RightArrowIcon */ .A, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, iconProps), {
                    arrowColor: scrollPercentage >= 100 ? (0,src_components_DesignSystem_ModernTheme_utils_common__WEBPACK_IMPORTED_MODULE_5__/* .hexToRgba */ .a7)(colorConfig.arrowColor, 0.5) : colorConfig.arrowColor
                }))
            }));
        }
    };
}


/***/ }),

/***/ 69466:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A": function() { return /* binding */ RightArrowIcon; },
/* harmony export */   "G": function() { return /* binding */ DownArrowIcon; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);




function RightArrowIcon(_param) {
    var _arrowColor = _param.arrowColor, arrowColor = _arrowColor === void 0 ? "#000" : _arrowColor, _bgColor = _param.bgColor, bgColor = _bgColor === void 0 ? "#fff" : _bgColor, _borderRadius = _param.borderRadius, borderRadius = _borderRadius === void 0 ? "5" : _borderRadius, _removeBorder = _param.removeBorder, removeBorder = _removeBorder === void 0 ? false : _removeBorder, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_param, [
        "arrowColor",
        "bgColor",
        "borderRadius",
        "removeBorder"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        xmlns: "http://www.w3.org/2000/svg",
        width: "24",
        height: "24",
        fill: "none",
        viewBox: "0 0 24 24"
    }, props), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                width: "24",
                height: "24",
                fill: bgColor,
                rx: borderRadius,
                transform: "matrix(-1 0 0 1 24 0)"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                width: "23.25",
                height: "23.25",
                x: "-0.375",
                y: "0.375",
                stroke: arrowColor,
                strokeOpacity: "0.12",
                strokeWidth: !removeBorder ? "0.75" : "0",
                rx: borderRadius,
                transform: "matrix(-1 0 0 1 23.25 0)"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
                clipPath: "url(#clip0_304_3140)",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    stroke: arrowColor,
                    strokeWidth: "1.5",
                    d: "M10.39 7.885l3.88 3.88-3.88 3.878"
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("defs", {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("clipPath", {
                    id: "clip0_304_3140",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        fill: "#fff",
                        d: "M0 0H13.714V13.714H0z",
                        transform: "matrix(0 1 1 0 5.14 5.143)"
                    })
                })
            })
        ]
    }));
}
function DownArrowIcon(_param) {
    var _arrowColor = _param.arrowColor, arrowColor = _arrowColor === void 0 ? "#fff" : _arrowColor, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_param, [
        "arrowColor"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        xmlns: "http://www.w3.org/2000/svg",
        width: "16",
        height: "16",
        fill: "none",
        viewBox: "0 0 16 16"
    }, props), {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("g", {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("mask", {
                        id: "mask0_666_6105",
                        style: {
                            maskType: "alpha"
                        },
                        width: "16",
                        height: "10",
                        x: "0",
                        y: "3",
                        maskUnits: "userSpaceOnUse",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                            fill: "#D9D9D9",
                            d: "M0 3H16V13H0z"
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
                        mask: "url(#mask0_666_6105)",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                            stroke: arrowColor,
                            strokeWidth: "1.6",
                            d: "M2.343 5.657L8 11.314l5.657-5.657"
                        })
                    })
                ]
            })
        })
    }));
}


/***/ }),

/***/ 34313:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "ListDescriptionSection": function() { return /* binding */ ListDescriptionSection; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(24200);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(93967);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _CardFrameCollection_components_CarouselIndicator__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(41993);
/* harmony import */ var src_utils_getStringFromHtmlTag__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(35400);
/* harmony import */ var _ListDescription_module_scss__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(15407);
/* harmony import */ var _ListDescription_module_scss__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_ListDescription_module_scss__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _NewAnnouncementBar_Components_InfiniteAutoScroller__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(73861);










function ListDescriptionSection(param) {
    var listPresentationConfig = param.listPresentationConfig, isMobile = param.isMobile, showArrow = param.showArrow, sectionColors = param.sectionColors, carouselIndicatorConfigs = param.carouselIndicatorConfigs, onNextArrowClick = param.onNextArrowClick, onPrevArrowClick = param.onPrevArrowClick, containerHorizontalPadding = param.containerHorizontalPadding, carouselConfigs = param.carouselConfigs, _isLogoSliderCarousel = param.isLogoSliderCarousel, isLogoSliderCarousel = _isLogoSliderCarousel === void 0 ? false : _isLogoSliderCarousel, _isFocusedReelExpandOnMobile = param.isFocusedReelExpandOnMobile, isFocusedReelExpandOnMobile = _isFocusedReelExpandOnMobile === void 0 ? false : _isFocusedReelExpandOnMobile, _isMoveableHeading = param.isMoveableHeading, isMoveableHeading = _isMoveableHeading === void 0 ? true : _isMoveableHeading, _showInstaHandle = param.showInstaHandle, showInstaHandle = _showInstaHandle === void 0 ? false : _showInstaHandle, _instaHandlePosition = param.instaHandlePosition, instaHandlePosition = _instaHandlePosition === void 0 ? "" : _instaHandlePosition, _instaHandle = param.instaHandle, instaHandle = _instaHandle === void 0 ? "" : _instaHandle, _isLayoutCarousel = param.isLayoutCarousel, isLayoutCarousel = _isLayoutCarousel === void 0 ? false : _isLayoutCarousel;
    var handleInstaClick = // const updatedHtmlForMoveableText = `<div style="display: flex; align-items: center; gap: 28px;"> <div style="height: 10px; width: 10px; border-radius: 50%; background: #111C36; opacity: .3;"></div> <div style = "font-weight: 400;">${listPresentationConfig?.heading} </div></div>`
    function handleInstaClick() {
        window.open("https://instagram.com/".concat(instaHandle), "_blank");
    };
    var alwaysShowInLeft = isMoveableHeading && (carouselConfigs === null || carouselConfigs === void 0 ? void 0 : carouselConfigs.arrowPosition) === "top";
    var displayLabelStyles = (0,_utils__WEBPACK_IMPORTED_MODULE_2__/* .getDisplayLabelStyles */ .KZ)(listPresentationConfig, alwaysShowInLeft);
    var ref = (0,_CardFrameCollection_components_CarouselIndicator__WEBPACK_IMPORTED_MODULE_4__.useGetChevronComponent)({
        type: carouselConfigs === null || carouselConfigs === void 0 ? void 0 : carouselConfigs.arrowShape,
        onNextArrowClick: onNextArrowClick,
        onPrevArrowClick: onPrevArrowClick,
        isMobile: isMobile,
        scrollPercentage: carouselIndicatorConfigs.scrollPercentage,
        colorConfig: {
            arrowColor: carouselConfigs === null || carouselConfigs === void 0 ? void 0 : carouselConfigs.arrowColor,
            shapeColor: carouselConfigs === null || carouselConfigs === void 0 ? void 0 : carouselConfigs.shapeColor
        }
    }), LeftArrow = ref.LeftArrow, RightArrow = ref.RightArrow;
    var headingText = (0,src_utils_getStringFromHtmlTag__WEBPACK_IMPORTED_MODULE_5__/* .getTitleWithoutTags */ .f)(listPresentationConfig === null || listPresentationConfig === void 0 ? void 0 : listPresentationConfig.heading);
    var descriptionText = (0,src_utils_getStringFromHtmlTag__WEBPACK_IMPORTED_MODULE_5__/* .getTitleWithoutTags */ .f)(listPresentationConfig === null || listPresentationConfig === void 0 ? void 0 : listPresentationConfig.description);
    var isEmptyText = !(headingText || descriptionText);
    var isTextCenter = listPresentationConfig.textAlign === "center";
    var showInstaUserName = function() {
        return instaHandle && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            onClick: handleInstaClick,
            className: "tw-mt-[8px] hover:tw-underline tw-leading-[1.4] tw-cursor-pointer [&>*]:tw-m-0 [&>*]:tw-text-inherit tw-text-[14px] tw-font-normal tw-text-[#111C36B2]",
            style: {
                textAlign: (listPresentationConfig === null || listPresentationConfig === void 0 ? void 0 : listPresentationConfig.textAlign) === "center" ? "center" : "left"
            },
            children: "@".concat(instaHandle)
        });
    };
    var renderMoveableHeadingContent = function() {
        /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "tw-flex tw-items-center tw-gap-[28px] tw-mt-[26px]",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "tw-h-[10px] tw-w-[10px] tw-rounded-[50%] tw-bg-newBlack tw-opacity-30"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "tw-m-0 tw-mb-[4px] [&>*]:tw-m-0 [&>*]:tw-font-normal [&>*]:tw-text-inherit tw-w-max ".concat(isTextCenter ? "tw-text-center" : "", " ").concat((_ListDescription_module_scss__WEBPACK_IMPORTED_MODULE_7___default().group)),
                    style: {
                        color: sectionColors === null || sectionColors === void 0 ? void 0 : sectionColors.text
                    },
                    dangerouslySetInnerHTML: {
                        __html: listPresentationConfig === null || listPresentationConfig === void 0 ? void 0 : listPresentationConfig.heading
                    }
                })
            ]
        });
    };
    var renderMoveableHeading = function() {
        /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_NewAnnouncementBar_Components_InfiniteAutoScroller__WEBPACK_IMPORTED_MODULE_6__/* .InfiniteAutoScroller */ .k, {
            gap: 28,
            scrollSpeedInSec: 4,
            totalItems: 4,
            wrapperClasses: "!tw-flex-none",
            customClasses: "!tw-m-0",
            maxWidth: isMoveableHeading && (carouselConfigs === null || carouselConfigs === void 0 ? void 0 : carouselConfigs.arrowPosition) === "top" && isLayoutCarousel && !isMobile ? "90%" : "100%",
            children: [
                renderMoveableHeadingContent(),
                renderMoveableHeadingContent(),
                renderMoveableHeadingContent(),
                renderMoveableHeadingContent()
            ]
        });
    };
    return !isEmptyText && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: classnames__WEBPACK_IMPORTED_MODULE_3___default()("tw-relative tw-mx-auto tw-flex tw-flex-col", !isEmptyText || showArrow ? isMobile ? !isLogoSliderCarousel ? isFocusedReelExpandOnMobile ? "tw-mb-[36px]" : "tw-mb-[24px]" : "" : isLogoSliderCarousel ? "tw-mb-[1px]" : "tw-mb-[36px]" : "", (listPresentationConfig === null || listPresentationConfig === void 0 ? void 0 : listPresentationConfig.descriptionPosition) === "top" ? "tw-flex-col-reverse" : ""),
        style: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, displayLabelStyles), {
            padding: isMoveableHeading ? 0 : "0px ".concat(containerHorizontalPadding, "px")
        }),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "tw-flex tw-w-[100%] tw-flex-col",
                style: displayLabelStyles,
                children: [
                    isMoveableHeading && renderMoveableHeading(),
                    !isMoveableHeading && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "tw-m-0 tw-mb-[4px] [&>*]:tw-m-0 [&>*]:tw-font-normal [&>*]:tw-text-inherit ".concat(isTextCenter ? "tw-text-center" : ""),
                        style: {
                            color: sectionColors === null || sectionColors === void 0 ? void 0 : sectionColors.text
                        },
                        dangerouslySetInnerHTML: {
                            __html: listPresentationConfig === null || listPresentationConfig === void 0 ? void 0 : listPresentationConfig.heading
                        }
                    }),
                    !isMobile && showArrow && (carouselConfigs === null || carouselConfigs === void 0 ? void 0 : carouselConfigs.arrowPosition) === "top" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "tw-absolute tw-right-0 tw-top-[50%] tw-flex tw-translate-y-[calc(-50%_-_2px)] tw-gap-[8px]",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(LeftArrow, {}),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(RightArrow, {})
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                style: {
                    justifyContent: showInstaHandle ? (listPresentationConfig === null || listPresentationConfig === void 0 ? void 0 : listPresentationConfig.textAlign) === "center" ? "center" : "left" : ""
                },
                className: "tw-w-[100%] ".concat(showInstaHandle ? !isMobile ? "tw-flex tw-items-center" : "tw-flex tw-flex-col" : ""),
                children: [
                    descriptionText && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "tw-m-0 tw-mt-[8px] tw-leading-[1.4] [&>*]:tw-m-0 [&>*]:tw-text-inherit tw-mr-[8px]",
                        style: {
                            color: "#808080",
                            textAlign: (listPresentationConfig === null || listPresentationConfig === void 0 ? void 0 : listPresentationConfig.textAlign) === "center" ? "center" : "left"
                        },
                        dangerouslySetInnerHTML: {
                            __html: listPresentationConfig === null || listPresentationConfig === void 0 ? void 0 : listPresentationConfig.description
                        }
                    }),
                    showInstaHandle && instaHandlePosition === "description" && showInstaUserName()
                ]
            })
        ]
    });
}


/***/ }),

/***/ 35400:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "f": function() { return /* binding */ getTitleWithoutTags; }
/* harmony export */ });
/* harmony import */ var _checkRenderEnv__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(6337);

var getTitleWithoutTags = function(title) {
    if (_checkRenderEnv__WEBPACK_IMPORTED_MODULE_0__/* .IS_SERVER */ .W6) {
        return title;
    }
    var htmlString = title;
    var tempDiv = document.createElement("div");
    tempDiv.innerHTML = htmlString;
    var text = tempDiv.textContent || tempDiv.innerText;
    return text;
};


/***/ }),

/***/ 15407:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"carousel":"ListDescription_carousel__BqFQE","scroll-wrapper":"ListDescription_scroll-wrapper__tO9LD","scrolling":"ListDescription_scrolling__gPibI","group":"ListDescription_group__10ocQ"};

/***/ })

}]);